import React from "react";
import Link from "next/link";

import { Price } from "../../../_components/Price";

import classes from "./index.module.scss";
import {Media} from "../../../../payload/payload-types";
import Image from "next/image";

function RelatedProducts(relatedProducts) {
  return (
    <div>
      <h3 className={classes.relatedPostsTitle}>You might also like</h3>
      {relatedProducts.relatedProducts?.map((product) => {
        //console.log(product);
        const { meta } = product;
        const { description, image: metaImage } = meta || {};
        //const media = process.env.NEXT_PUBLIC_SERVER_URL + "/media/" + product.meta?.image?.filename;
          const media = product?.meta?.image as Media;
        return (
          <Link
            className={classes.productBlock}
            key={product.id}
            href={"/products/" + product.slug}
          >
            <div className={classes.mediaWrapper}>
              {!metaImage && <div className={classes.productImg}>No image</div>}
              {metaImage && typeof metaImage !== "string" && (
                  <Image
                      className={classes.productImg}
                      src={`${media.url}`}
                      alt={`${media.alt}`}
                      blurDataURL={`${media.url}`}
                      placeholder={"blur"}
                      loading="lazy"
                      fill={true}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
              )}
            </div>
            <div className={classes.productTitle}>{product.title}</div>
            <Price product={product} />
          </Link>
        );
      })}
    </div>
  );
}

export default RelatedProducts;
